import React, { useState } from "react";
import {
  BoxContainer,
  BoxHead,
  BoxTitle,
  Underline,
} from "../../Components/Styles/PageStyles";
import ReportSpecs from "../../Components/Reports/ReportSpecs";
import NotFoundModel from "../../Components/NotFoundModel";
import tw from "tailwind-styled-components";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const CreateReports = () => {
  const location = useLocation();
  const reportType = location.state?.reportType;
  const [filterType, setFilterType] = useState("1");
  const propertyList = useSelector((state) => state.PropertyReducer.property);

  const reportTitles = {
    1: "Create Collection Report",
    2: "Create Dues Report",
    3: "Create Tenant Report",
    4: "Create Expenses Report",
    5: "Create Room Occupancy Report",
    6: "Create Bed Occupancy Report",
  };

  const pageTitle = reportTitles[reportType] || "Create Report";
  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          {pageTitle}
          <Underline />
        </BoxTitle>
      </BoxHead>
      <ButtonGroup>
        <TemplateButton
          isActive={filterType === "1"}
          onClick={() => setFilterType("1")}
        >
          Download
        </TemplateButton>
      </ButtonGroup>
      <Seperator />
      {filterType === "1" ? (
        <ReportSpecs propertyList={propertyList} reportType={reportType} />
      ) : (
        <NotFoundModel />
      )}
    </BoxContainer>
  );
};
const ButtonGroup = tw.div`flex items-center !gap-0`;
const TemplateButton = tw.button`
  px-2 font-semibold relative ${(props) =>
    props.isActive ? "text-blue-500" : "text-gray-600"}
  ${(props) => (props.ml ? "ml-2" : "")}
  after:absolute after:top-8 after:left-0 after:w-full after:h-0.5
  ${(props) => (props.isActive ? "after:bg-blue-500" : "")}
`;
const Seperator = tw.div`w-full h-[0.090rem] bg-gray-200 mt-2`;
export default CreateReports;
